// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'babel-polyfill'
import router from './router'
import store from './store/index'
import ElementUI from 'element-ui'
import axios from './http'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/fonts/led_fonts.css'
import cookie from './utils/cookie.js'
// import VueAMap from 'vue-amap'
import { btn_extimate, BTN } from '@/utils/btnAuth.js'
import VueClipboard from 'vue-clipboard2'
// e6相关
import e6BaseUrl from './e6GetBaseUrl.js'
import VueAMap from 'vue-amap'
import '@/common/e6Common/e6Font/iconfont.css'
import global from '@/utils/global' // 全局弹框

import E6City from 'e6city'
Vue.use(E6City)

Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: 'd60a665f8934776235f28c4a93dee85d',
  plugin: [
    'Autocomplete',
    'PlaceSearch',
    'Scale',
    'OverView',
    'ToolBar',
    'MapType',
    'AMap.MouseTool',
    'AMap.MarkerClusterer',
    'AMap.Geocoder'
  ],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4',
  uiVersion: '1.0.11' // UI版本号
})
Vue.prototype.lockScroll = true
Vue.config.productionTip = false

Vue.config.devtools = true
Vue.prototype.$axios = axios
Vue.prototype.$e6BaseUrl = e6BaseUrl
Vue.prototype.closeModal = false
Vue.prototype.btn_extimate = btn_extimate
Vue.prototype.BTN = BTN
Vue.use(ElementUI)
Vue.use(VueClipboard)
Vue.use(global)
// Vue.use(VueAMap)
// VueAMap.initAMapApiLoader({
//   key:'e017ec79746cdbd0de676eeb840a76a7',
//   plugin:['AMap.Geolocation','AMap.Geocoder','AMap.Driving'],
//   uiVersion:'1.0.11'
// })

// const loadmore = Vue.directive('loadmore', {
//   bind(el, binding) {
//     const selectWrap = el.querySelector('.el-table__body-wrapper')
//     selectWrap.addEventListener('scroll', function() {
//       let sign = 100
//       const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight
//       if (scrollDistance <= sign) {
//         binding.value()
//       }
//     })
//   }
// })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  // loadmore,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js